import { createContext, useContext } from 'react';

import IQueue from 'lib/common/types/InstanceQueue';
import TRedactedDirectory from 'lib/common/types/RedactedDirectory';

type InstanceContextType = {
  instanceQueues: IQueue[];
  instanceDirectories: Record<string, TRedactedDirectory>;
};

const Context = createContext<InstanceContextType>({
  instanceQueues: [],
  instanceDirectories: {},
});

// export the context hook
export const useInstanceContext = () => useContext(Context);

export default Context;
